<script>
    import Header from './Header.svelte';
    import Body from './Body.svelte';
</script>

<Header/>
<Body/>
